import type { KnownRowKeys, KeyValueRowProps, RowPropsGetterArgs } from './types';

export const orderSummaryRows: Record<KnownRowKeys, { getProps(args: RowPropsGetterArgs): KeyValueRowProps }> = {
    subtotal: {
        getProps({ value, count, ...rest }) {
            return {
                title: `Subtotal (${count} item${count === 1 ? '' : 's'})`,
                value,
                weight: 'light',
                ...rest,
            };
        },
    },
    additionalSavings: {
        getProps({ value, ...rest }) {
            return {
                title: 'Additional savings',
                value: -Math.abs(Number(value)) || 0,
                variant: 'light-sale',
                hide: value === '0.00',
                ...rest,
            };
        },
    },
    shippingDiscountApplied: {
        getProps({ value, ...rest }) {
            return {
                title: 'Shipping discount applied',
                variant: 'light-sale',
                value: -Math.abs(Number(value)),
                hide: value === '0.00',
                ...rest,
            };
        },
    },
    shipping: {
        getProps({ value, fulfillmentMethod, ...rest }) {
            const isFreeShipping = value === '0.00';
            const isSdd = fulfillmentMethod?.includes('sdd');

            return {
                title: isSdd ? 'Delivery' : 'Shipping',
                value,
                customValue: isFreeShipping ? 'FREE' : null,
                weight: 'light',
                ...rest,
            };
        },
    },
    treatsRewardsPointsApplied: {
        getProps({ value, ...rest }) {
            return {
                title: 'Treats Rewards points',
                value: -Math.abs(Number(value)) || 0,
                variant: 'light-sale',
                hide: Number(value) <= 0,
                ...rest,
            };
        },
    },
    bagFee: {
        getProps({ value, count, ...rest }) {
            return {
                title: `Bag fee (${count} bag${count === 1 ? '' : 's'})`,
                value,
                weight: 'light',
                ...rest,
            };
        },
    },
    estimatedBagFee: {
        getProps({ value, ...rest }) {
            return {
                title: 'Estimated Bag Fee',
                value,
                weight: 'light',
                ...rest,
            };
        },
    },
    dasherTip: {
        getProps({ value, ...rest }) {
            return {
                title: 'Dasher tip',
                value,
                weight: 'light',
                ...rest,
            };
        },
    },
    giftCardsApplied: {
        getProps({ value, ...rest }) {
            return {
                title: 'Gift cards applied',
                value: -`${value}`,
                variant: 'light-sale',
                ...rest,
            };
        },
    },
    charitiesDonation: {
        getProps({ value, ...rest }) {
            return {
                title: 'Charities donation',
                value,
                weight: 'light',
                ...rest,
            };
        },
    },
    total: {
        getProps({ value, ...rest }) {
            return {
                title: 'Total',
                value,
                bold: true,
                className: 'order-summary__total',
                'data-cs-mask': true,
                ...rest,
            };
        },
    },
    tax: {
        getProps({ value, ...rest }) {
            return {
                title: 'Tax',
                weight: 'light',
                value,
                ...rest,
            };
        },
    },

    // --- use when you want to render custom rows
    custom: {
        getProps(props: KeyValueRowProps) {
            return props;
        },
    },
} as const;
